import { memo } from 'react'
import useI18n from 'src/hooks/use_i18n'
import { filterRegex } from 'src/utils/carriers_info'

// #region component
interface Props {
  carrierName?: string
  carriersInfoData?: any
}

function WhyIntegrate({ carriersInfoData, carrierName = '17track' }: Props) {
  const { $t, i18nFormatAll } = useI18n()

  return (
    <>
      <div itemProp="mainEntity" itemScope itemType="https://schema.org/Question">
        <h2 id={filterRegex(`integrate${carrierName}`, /[ ?]/g, '-')} itemProp="name">
          {carriersInfoData?.commonConfig?.whyIntegrate ??
            i18nFormatAll($t('ResCarrierListPDetails.global.__whyIntegrate_question'), {
              carriersName: carrierName
            })}
        </h2>
        <div itemProp="acceptedAnswer" itemScope itemType="https://schema.org/Answer">
          <div itemProp="text">
            <p>
              ✅ {$t('ResCarrierListPSeoDetails.global.__pWhyInergrate_type1')}
              {$t('ResCarrierListPSeoDetails.global.__pWhyInergrate_type1Answer')}
            </p>
            <p>
              ✅ {$t('ResCarrierListPSeoDetails.global.__pWhyInergrate_type2')}
              {$t('ResCarrierListPSeoDetails.global.__pWhyInergrate_type2Answer')}
            </p>
            <p>
              ✅ {$t('ResCarrierListPSeoDetails.global.__pWhyInergrate_type3')}
              {$t('ResCarrierListPSeoDetails.global.__pWhyInergrate_type3Answer')}
            </p>
            <p>
              ✅ {$t('ResCarrierListPSeoDetails.global.__pWhyInergrate_type4')}
              {$t('ResCarrierListPSeoDetails.global.__pWhyInergrate_type4Answer')}
            </p>
            <p>
              ✅ {$t('ResCarrierListPSeoDetails.global.__pWhyInergrate_type5')}
              {$t('ResCarrierListPSeoDetails.global.__pWhyInergrate_type5Answer')}
            </p>
            <p>
              ✅ {$t('ResCarrierListPSeoDetails.global.__pWhyInergrate_type6')}
              {$t('ResCarrierListPSeoDetails.global.__pWhyInergrate_type6Answer')}
            </p>
            <p>
              ✅ {$t('ResCarrierListPSeoDetails.global.__pWhyInergrate_type7')}
              {$t('ResCarrierListPSeoDetails.global.__pWhyInergrate_type7Answer')}
            </p>
          </div>
        </div>
      </div>
    </>
  )
}

export default memo(WhyIntegrate)
